import { createPinia } from 'pinia';
// import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import piniaPersist from 'pinia-plugin-persist';
import useLoginStore from './login';
import useLayoutStore from './layout';
import useOtherStore from './other';
import useMessage from './message';
import useStaticDictStore from './staticDict';
import useHomeStore from './home';

const pinia = createPinia();
pinia?.use(piniaPersist);
// pinia?.use(piniaPluginPersistedstate);
export {
  useLoginStore,
  useLayoutStore,
  useMessage,
  useOtherStore,
  useStaticDictStore,
  useHomeStore,
};
export default pinia;
